import { LEADERSHIP_TIER } from '@/constants/leadership-tier';
import type { AuthUser } from '@/types/auth';
import { USER_ROLES } from '@/constants/roles';

export function isSystemAdmin(user: AuthUser): boolean {
  return user.role === USER_ROLES.ADMIN;
}

export function canManageTeam(user: AuthUser): boolean {
  return user.canManageTeam;
}

/** TOP / 班子成员 / 单位负责人应进入领导端移动体验 */
export function hasLeadershipMobileTier(user: AuthUser): boolean {
  const tier = user.leadershipTier;
  if (!tier || tier === LEADERSHIP_TIER.NONE) {
    return false;
  }
  return (
    tier === LEADERSHIP_TIER.TOP_LEADER ||
    tier === LEADERSHIP_TIER.LEADERSHIP_MEMBER ||
    tier === LEADERSHIP_TIER.DEPARTMENT_LEADER
  );
}

/** 领导端移动体验：有团队管理、LEADER 角色，或具备领导身份 tier */
export function isLeaderExperience(user: AuthUser): boolean {
  return (
    user.role === USER_ROLES.LEADER ||
    canManageTeam(user) ||
    hasLeadershipMobileTier(user)
  );
}

/** 员工端移动体验：非管理员且非领导体验 */
export function isEmployeeExperience(user: AuthUser): boolean {
  return !isSystemAdmin(user) && !isLeaderExperience(user);
}
